import { Box } from '@mui/material'
import { Card } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import { useTranslation } from 'react-i18next'
import GenericFilter from '../EidFilter/GenericFilter'
import { useState } from 'react'

const LocationFilter = ({ url, queryKey, version = 'v3', queryParam }) => {
    const { t } = useTranslation()
    const [state] = usePageContext()
    const [expanded, setExpanded] = useState(false)

    const toggleExpand = () => {
        setExpanded(!expanded)
    }

    return (
        <Box
            sx={{
                width: expanded ? '800px' : 'auto',
                transition: 'height 0.3s ease',
                position: 'relative',
                zIndex: 1,
            }}
        >
            <Card
                cardTitle={t('Location')}
                collapsible
                expanded={Boolean(state.location)}
                onExpandChange={(viewMode) => {
                    if (!viewMode && expanded) {
                        setExpanded(false)
                    }
                }}
            >
                <Box
                    padding="0"
                    style={{
                        borderTop: 'solid 1px #efeff1',
                    }}
                >
                    <Box padding="20px 20px 0px 20px">
                        <GenericFilter
                            type="treewithsearch"
                            searchable="true"
                            searchPlaceholder={t('Search')}
                            url={
                                url || '/api/Lookups/managementRoles/Locations'
                            }
                            dedupingInterval={1800000}
                            contextProp="location"
                            version={version}
                            queryKey={queryKey}
                            queryParam={queryParam}
                            toggleExpand={toggleExpand}
                            isExpanded={expanded}
                        />
                    </Box>
                </Box>
            </Card>
        </Box>
    )
}

export default LocationFilter
